import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <div className="my-footer">
      <img
        src="images/nakajima-glass-logo.png"
        alt="corp-logo"
        width="114"
        height="56"
      />
    </div>
  );
};

export default Footer;
